import { render, staticRenderFns } from "./AssignExpertModal.vue?vue&type=template&id=aef14b18&scoped=true&"
import script from "./AssignExpertModal.vue?vue&type=script&lang=js&"
export * from "./AssignExpertModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignExpertModal.vue?vue&type=style&index=0&id=aef14b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef14b18",
  null
  
)

export default component.exports